/* eslint-disable react/jsx-curly-spacing */
/* eslint-disable array-bracket-spacing */
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import ModalHeader from 'react-bootstrap/ModalHeader';
import ModalTitle from 'react-bootstrap/ModalTitle';
import ModalBody from 'react-bootstrap/ModalBody';
import ModalFooter from 'react-bootstrap/ModalFooter';
import { Formik, Form } from 'formik';
import { Select2Nolabel } from 'view/component/FormFormik';
import { showLoading, toast } from 'view/component/Alert';
import apiService from 'apiService';
import Toastify from 'toastify-js';

const ModalUpdateProlanis = (props) => {
  const [visit, setVisit] = useState({
    id: props.data.id,
    prolanis: props.data.prolanis,
  });

  const values = [];

  useEffect(() => {
    const prolanis = props.data.prolanis;
    if (prolanis.includes('DM')) values.push({ id: 'dm', value: 'DM', label: 'Diabetes Millitus' })
    if (prolanis.includes('HT')) values.push({ id: 'ht', value: 'HT', label: 'Hipertensi' })
  }, [])

  const updateVisit = async () => {
    showLoading('Sedang Mengubah Data');
    if (visit.id > 0) {
      const res = await apiService.put('registration/change/visit', {
        visit,
      });
      if (res.code == 200) {
        Toastify({
          text: visit.prolanis !== '' ? 'Pasien sudah berhasil ditandai sebagai prolanis!' : 'Pasien sudah berhasil dihapus dari prolanis!',
          gravity: 'bottom'
        }).showToast();
        props.onHide();
      } else {
        toast({ status: 'error', text: 'Gagal Mengubah Data' });
      }
    } else {
      toast({ status: 'error', text: 'data belum dipilih' });
    }
  };
  return (
    <div>
      <Modal {...props} aria-labelledby="modal-user">
        <ModalHeader closeButton>
          <ModalTitle>
            <h3>Form Penanda Pasien Prolanis</h3>
          </ModalTitle>
        </ModalHeader>
        <Formik
          enableReinitialize
          initialValues={{
            ...visit,
          }}
          onSubmit={() => {
            updateVisit();
          }}
        >
          {({ errors, touched }) => (
            <Form>
              <ModalBody>
                <div className='mb-1'>
                  Pasien ini akan ditandai sebagai Prolanis kelompok
                </div>
                <Select2Nolabel
                  label='Diabetes Millitus'
                  onChange={(e) => {
                    let val = ''
                    if (e) {
                      val = e.map((item) => item.value).join(', ')
                    }
                    setVisit({ ...visit, prolanis: val })
                  }
                  }
                  isMulti
                  value={values}
                  errors={errors}
                  touched={touched}
                  option={[
                    { id: 'dm', value: 'DM', label: 'Diabetes Millitus' },
                    { id: 'ht', value: 'HT', label: 'Hipertensi' }
                  ]}
                  name='prolanis'
                />
              </ModalBody>
              <ModalFooter>
                <button
                  type="button"
                  onClick={() => {
                    props.onHide();
                  }}
                  className="btn btn-secondary"
                >
                  Batal
                </button>
                <button type="submit" className="btn btn-primary">
                  Simpan Data
                </button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </Modal>
    </div>
  );
};

export default ModalUpdateProlanis;
